import * as React from 'react'
const Divider = props => (
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 13H6V1H5V13Z" fill="#C4C6D2"/>
  </svg>
)

export default Divider